"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DnaRSpinnerMode;
(function (DnaRSpinnerMode) {
    DnaRSpinnerMode["indeterminate"] = "indeterminate";
    DnaRSpinnerMode["determinate"] = "determinate";
})(DnaRSpinnerMode = exports.DnaRSpinnerMode || (exports.DnaRSpinnerMode = {}));
